import { useDispatch, useSelector, useStore } from 'react-redux';

// Typed hooks live in `shared` so every layer imports them downward. The store's
// `RootState`/`AppDispatch` come from the local registry (`./types`), which `app`
// augments — so `shared` never imports `app` and the graph stays acyclic.
import type { AppDispatch, AppStore, RootState } from './types';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
/** For listeners outside render only; components read through `useAppSelector`. */
export const useAppStore = useStore.withTypes<AppStore>();
